// extracted by mini-css-extract-plugin
export default {"dropzone":"PalletsToSendFileDropzone_dropzone__w46Kd","excelUploadBtn":"PalletsToSendFileDropzone_excelUploadBtn__gASGZ","description":"PalletsToSendFileDropzone_description__pY7Gt"};